/******************************************************************************************
 *	Unsupported Browser Controller
 ******************************************************************************************/
(function() {
  angular.module('rcControllers.cookiesDisabled', []).controller(
    'CookiesDisabledController',
    /* @ngInject */
    function(BlackoutError) {
      BlackoutError.showCookiesDisabledError();
    }
  );
})();
